import { useEffect } from "react";

import NotFoundPage from "components/error/NotFoundPage";
import SpaceliftLoader from "components/loading/SpaceliftLoader";
import useFlowsIntegration from "shared/Flows/useFlowsIntegration";
import setLocation from "shared/setLocation";

const FLOWS_LOGIN_ENDPOINT = "/flows/login";

/**
 * Completes a login that reached the app instead of the backend. /flows/login is a backend
 * endpoint that 302s to Flows, but CloudFront rewrites its 404 for a caller without a session
 * into index.html, so the app boots here, sends the user through login and then restores the
 * path with a router navigation. Only a document load reaches the endpoint.
 */
const FlowsLogin = () => {
  const { isLinked, loading } = useFlowsIntegration();

  useEffect(() => {
    if (isLinked) {
      setLocation(FLOWS_LOGIN_ENDPOINT);
    }
  }, [isLinked]);

  // flowsIntegration resolves under the same conditions the endpoint requires, so without a
  // link it would answer 404 and land us back here: stop rather than reload into it.
  if (!loading && !isLinked) {
    return <NotFoundPage />;
  }

  return <SpaceliftLoader />;
};

export default FlowsLogin;
